module.exports = __webpack_public_path__ + "static/media/dashboard-banner-mtn.58e289a9.png";